import { createApp } from 'vue';
import { createRouter as _createRouter, createWebHistory } from 'vue-router';
import { initSentry, getEnvVar } from '@utils';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Cloudinarize from '@plugins/cloudinarize';
import parentLogin from '@components/login.vue';
import parentRegister from '@parent/components/register.vue';

const router = _createRouter({
  history: createWebHistory(),
  routes: [],
});

initSentry();

if (document.getElementById('parent-authentication-vue')) {
  const app = {
    router,
    components: {
      parentLogin,
      parentRegister,
    },
    methods: {
      switchToLogin() {
        $('#registrationModal').modal('hide');
        $('#loginModal').modal('show');
      },
    },
  };

  createApp(app)
    .use(router)
    .use(Cloudinarize)
    .use(VueReCaptcha, {
      siteKey: getEnvVar('RECAPTCHA_SITE_KEY'),
      loaderOptions: {
        useEnterprise: true,
        renderParameters: {
          badge: 'bottomleft',
        },
      },
    })
    .mount('#parent-authentication-vue');
}
